<template>
    <div class="investment_warp">
      <SearchHunt
        :filterData="filterData"
        @handle_seach="handle_seach"
        ref="SearchHunt"
      />
      <a-table
        class="antd-table"
        bordered
        :columns="relevanceBatch_grid.field"
        :data-source="relevanceBatch_grid.row"
        rowKey="id"
        size="small"
        :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
        :pagination="false"
        :loading="tableLoading"
      >
        <!-- 序号 -->
        <span slot="index" slot-scope="text, record, index">
          {{index + (pageParam.pageNum-1) * pageParam.pageSize + 1}}
        </span>
        <!-- 赠予方式 -->
        <span slot="giftType" slot-scope="text, record">
          {{ text | DictionaryFilter('GIFT_TYPE') }}
        </span>
        <!-- 权益状态 -->
        <span slot="equityStatus" slot-scope="text, record">
          <span v-if="record.equityStatus == '1' || record.equityStatus == '5'"><a-badge color="gold" /></span>
        <span v-else-if="record.equityStatus == '2'"><a-badge color="red"/></span>
        <span v-else><a-badge color="cyan" /></span>
          {{ text | DictionaryFilter('EQUITY_STATUS') }}
        </span>
         <!-- 二维码图片 -->
         <span slot="equityOrId" slot-scope="text, record">
              <img v-if="record.giftType =='2'"
                style="height: 50px;max-width: 100%;  margin-right: 4px"
                :src="url + record.equityOrId"
                @click="handleImg(record.equityOrId)"
              />
          </span>
        <!-- 更多操作 -->
        <span slot="operation" slot-scope="data" class="ellipsis">
          <a v-if="data.giftType =='1' && data.equityStatus == '1'" @click="handle_update(data)">绑卡</a>
          <a v-if="data.giftType =='1' && data.equityStatus == '5'" @click="handle_delivery(data.id)">去发货</a>
          <a v-if="data.equityStatus != '5'" @click="handle_detail(data,data.giftType)">详情</a>
        </span>
      </a-table>
      <!-- 放大图片展示效果 -->
      <a-modal
        :visible="previewVisible"
        :footer="null"
        @cancel="handleCancelImg"
        class="imgBox"
      >
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>

      <!-- 底部 -->
      <div class="table_bottom">
  
        <!-- 分页 -->
        <div>
          <a-pagination
            class="table_pagination"
            show-size-changer
            :default-current="1"
            v-model="pageParam.pageNum"
            :show-total="(total) => `共 ${total} 条`"
            :page-size-options="pageSizeOptions"
            size="small"
            :total="total"
            @showSizeChange="onShowSizeChange"
            @change="paginationChange"
            :page-size.sync="pageParam.pageSize"
          />
        </div>
      </div>
  
      <!-- 表单 -->
      <!-- 添加 -->
      <addModal
        v-if="addVisible"
        :modalTitle="addTitle"
        :addData="addData"
        @close="close" 
        @handleOk="addlHandleOk"
      ></addModal>
      <!-- 去发货 -->
      <deliveryModal
        v-if="deliveryVisible"
        :modalTitle="deliveryTitle"
        :giftId="giftId"
        @close="deliveryClose" 
        @handleOk="deliverylHandleOk"
      ></deliveryModal>
    </div>
  </template>
  
  <script>
  import {
    queryGift,
  } from "@/api/api.js";
  import SearchHunt from "./components/search-hunt/search-hunt.vue";
  import addModal from "./components/modal-hunt/add-modal.vue";
  import deliveryModal from "./components/modal-hunt/delivery-modal.vue";
  import { DictionaryService } from "@common/services/dictionary.service";
  export default {
    name: "",
    components: {
      SearchHunt,
      addModal,
      deliveryModal
    },
    data() {
      return {
        //搜索栏
        filterData: [
          {
            name: "giftType",
            type: "select",
            value: undefined,
            label: "请选择赠与方式",
            options: [],
            placeholder:"赠与方式：",
          },
          {
            name: "equityStatus",
            type: "select",
            value: undefined,
            label: "请选择权益状态",
            options: [],
            placeholder:"权益状态：",
          },
        ],
        relevanceBatch_grid: {
          height: "calc(100vh - 250px)",
          width: 0, // 宽度
          row: [],
          field: [
            {
              title: "序号",
              align: "center",
              width: 60,
              dataIndex: "index",
              ellipsis: true,
              scopedSlots: {
                customRender: "index",
              },
            },
            {
              title: "赠予权益商品名称",
              align: "center",
              width: 150,
              dataIndex: "prName",
              ellipsis: true,
            },
            {
              title: "赠与人",
              align: "center",
              width: 100,
              dataIndex: "giftCustName",
              ellipsis: true,
            },
            {
              title: "被赠与人",
              align: "center",
              width: 100,
              dataIndex: "custName",
              ellipsis: true,
            },
            {
              title: "说明",
              align: "center",
              width: 150,
              dataIndex: "remark",
              ellipsis: true,
            },
            {
              title: "赠予方式",
              colSpan: 1,
              width: 100,
              dataIndex: "giftType",
              align: "center",
              ellipsis: true,
              scopedSlots: {
                customRender:"giftType",
              }
            },
            {
              title: "赠予数量",
              colSpan: 1,
              align: "center",
              width: 80,
              ellipsis: true,
              dataIndex: "giftCount",
            },
            {
              title: "赠予权益价值",
              colSpan: 1,
              align: "center",
              width: 140,
              ellipsis: true,
              dataIndex: "giftPrice",
            },
            {
              title: "权益状态",
              colSpan: 1,
              align: "center",
              width: 120,
              ellipsis: true,
              dataIndex: "equityStatus",
              scopedSlots: {
                customRender:"equityStatus",
              },
            },
            {
              title: "创建时间",
              align: "center",
              colSpan: 1,
              ellipsis: true,
              width: 170,
              dataIndex: "createTime",
              scopedSlots: { customRender: "createTime" },
            },
            {
              title: "二维码",
              align: "center",
              width: 140,
              dataIndex: "equityOrId",
              scopedSlots: { customRender: "equityOrId" },
            },
            {
              title: "操作",
              width: 120,
              align: "center",
              scopedSlots: {
                customRender: "operation",
              },
            },
          ]
        },
        pageParam: {
          pageNum: 1,
          pageSize: 10,
          orderBy: ""
        },
        pageSizeOptions: ["10", "20", "50", "100"],
        total: 0,
        paramsObj: {
          giftType: null,
          custName: null,
          cardNo: null,
          equityStatus:null
        },
        previewVisible: false,
        previewImage: "",
        url: "",
        list: [],
        selectedRows:[],//多选数据
        //批量审核弹窗
        operateVisible: false,
        operateTitle:"",
        operateContent: [],
        operateDate:"",
        //再次确认弹窗
        secondConfirmVisible: false,
        secondConfirmTitle: "",
        secondConfirmContent: "",
        secondConfirmData:"",
        //添加弹窗
        addVisible: false,
        addTitle:"",
        addData:{},
        //去发货弹窗
        deliveryVisible: false,
        deliveryTitle:"",
        //查询加载
        tableLoading:false,
        giftId:"",
        giftInfo:[],//赠予信息
      };
    },
    mounted() {
      // 获取字典
      DictionaryService.getAllNeedDic(["GIFT_TYPE","EQUITY_STATUS"]).then((res) => {
        //赠予方式
        this.filterData[0].options = DictionaryService.getOptions("GIFT_TYPE");
        //权益状态
        this.filterData[1].options = DictionaryService.getOptions("EQUITY_STATUS");
        this.url = process.env.VUE_APP_PROXY + "base/file/download-file?id=";
        //查询
        this.queryList();
      }); 
      this.relevanceBatch_grid.width = 0;
      this.relevanceBatch_grid.field.map(item => {
        this.relevanceBatch_grid.width += item.width;
      });
    },
    methods: {
      /* 表格图片查看 */
      handleImg(file) {
        this.previewVisible = true;
        this.bigurl = process.env.VUE_APP_PROXY + "base/file/download-file?id=";
        this.previewImage = this.bigurl + file;
      },
      /* 表格图片关闭 */
      handleCancelImg() {
        this.previewVisible = false;
      },
      paginationChange(page, pageSize) {
        this.pageParam.pageNum = page;
        this.queryList();
      },
      onShowSizeChange(current, size) {
        this.pageParam.pageSize = size;
        this.pageParam.pageNum = 1;
        this.queryList();
      },
      // 查询
      handle_seach(params) {
        this.paramsObj = params;
        this.pageParam.pageNum = 1;
        this.queryList();
      },
      queryList() {
        this.tableLoading = true;
        queryGift({
          pageParam: {
            pageNum: this.pageParam.pageNum,
            pageSize: this.pageParam.pageSize,
            orderBy: ""
          },
          content: this.paramsObj
        })
        .then((res) => {
          if (res.content.rows && res.content.rows.length) {
            this.relevanceBatch_grid.row = res.content.rows;
            this.total = res.content.page.totalRows;
          } else {
            this.relevanceBatch_grid.row = [];
            this.total = 0;
          }
          this.tableLoading = false;
        }, (err) => {
          this.tableLoading = false;
        });
      },
      handle_upload(){

      },
      //待发货
      handle_delivery(data) {
        this.deliveryVisible = true;
        this.deliveryTitle = "订单发货";
        this.giftId = data;
      },
      //绑卡
      handle_update(data) {
        this.addVisible = true;
        this.addTitle = "权益绑定（实体卡）";
        this.addData = data;
      },
       //添加弹窗确认
       addlHandleOk() {
        this.queryList();
        this.addVisible = false;
      },
      //弹窗关闭
      close() {
        this.addData=[];
        this.addVisible = false;
      },
      //去发货弹窗确认
      deliverylHandleOk() {
        this.queryList();
        this.deliveryVisible = false;
      },
      //去发货弹窗关闭
      deliveryClose() {
        this.deliveryVisible = false;
      },
      //详情
      handle_detail(data,type) {
        this.giftInfo = [];
        this.giftInfo.push(data);
        this.$router.push({path:'/home/customer-management/gift-benefits/pages/operate',query:{giftId:data.id,giftData:JSON.stringify(this.giftInfo),giftType:type}})
      },
    },
  };
  </script>
  
  <style scoped lang="less">
  .select_width {
    width: 180px !important;
  }
  .ellipsis {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .investment_flex {
    display: flex;
    margin-bottom: 15px;
  }
  .investment_li {
    margin-right: 15px;
  }
  .custom {
    margin: 5px;
    color: #4093e1;
    cursor: pointer;
  }
  .table_pagination {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  
  .box_warp {
    overflow-y: auto;
  }
  .end {
    justify-content: flex-end;
  }
  .sp_name {
    display: inline-block;
    font-size: 20px;
    margin: 10px 0px;
    margin-bottom: 20px;
    padding: 0 5px;
    border-left: 5px solid #0b2464;
  }
  
  .table_bottom{
  
    .bottom_btn{
      margin-top: 10px;
  
      .btn_first{
        margin-right: 10px;
      }
    }
  }
  </style>